export const common = {
  // Navigation
  nav_home: 'Home',
  nav_categories: 'Categories',
  nav_guides: 'Guides',
  nav_reviews: 'Reviews',
  nav_shipping: 'Shipping',
  nav_about: 'About',
  nav_contact: 'Contact',
  
  // Language
  language: 'Language',
  lang_en: 'English',
  lang_de: 'Deutsch',
  lang_fr: 'Français',
  lang_da: 'Dansk',
  
  // Hero
  hero_title: 'AllChinaBuy Spreadsheet — Find Products, Links & Trusted Finds',
  hero_subtitle: 'Explore the latest AllChinaBuy spreadsheet resources, product finds, buying guides, QC information, shipping guides and useful product links — all organized in one place.',
  hero_cta_primary: 'Explore AllChinaBuy Spreadsheet',
  hero_cta_secondary: 'Visit Main Website',
  
  // Search
  search_placeholder: 'Search products, categories or AllChinaBuy spreadsheet resources...',
  
  // Categories
  categories_title: 'Popular Categories',
  categories_subtitle: 'Browse our curated product categories and find exactly what you need',
  category_shoes: 'Shoes',
  category_hoodies: 'Hoodies / Sweaters',
  category_tshirts: 'T-Shirts',
  category_jackets: 'Jackets',
  category_pants: 'Pants / Shorts',
  category_headwear: 'Headwear',
  category_sets: 'Sets',
  category_underwear: 'Underwear / Underpants',
  category_jersey: 'Jersey',
  category_accessories: 'Accessories',
  category_bags: 'Bags',
  category_belts: 'Belts',
  category_perfumes: 'Perfumes',
  category_other: 'Other Stuff',
  
  // CTA Buttons on homepage
  cta_allchinabuy_spreadsheet: 'AllChinaBuy Spreadsheet',
  cta_buy_it_now: 'Buy It Now',
  
  // About section
  about_title: 'What is AllChinaBuy Spreadsheet?',
  about_p1: 'AllChinaBuy Spreadsheet is your ultimate resource hub for discovering high-quality products, trusted seller links, and detailed buying guides for the AllChinaBuy platform. We curate the best finds across shoes, clothing, accessories, and more — saving you hours of research.',
  about_p2: 'Our mission is simple: connect European shoppers with the best AllChinaBuy products while providing honest reviews, shipping guides, and safety tips. Every link and recommendation is carefully vetted to ensure you get genuine value.',
  about_cta: 'Learn More About Us',
  
  // Article Preview
  article_title: 'AllChinaBuy Spreadsheet Guide',
  article_excerpt: 'Discover how to use the AllChinaBuy spreadsheet effectively to find the best products, verify sellers, and save on shipping costs. This complete guide covers everything from beginner basics to advanced product research techniques.',
  article_read_more: 'Read Full Guide',
  article_meta: '8 min read • Updated August 2026',
  
  // Trust badges
  trust_title: 'Why Shoppers Trust Us',
  trust_1_title: 'Curated Finds',
  trust_1_desc: 'Every product is hand-picked and verified by our team',
  trust_2_title: 'Shipping Guides',
  trust_2_desc: 'Detailed shipping cost breakdowns and delivery timelines',
  trust_3_title: 'Safe Shopping',
  trust_3_desc: 'Safety tips and scam prevention strategies included',
  trust_4_title: 'Regular Updates',
  trust_4_desc: 'Spreadsheets and links updated weekly for accuracy',
  
  // Footer
  footer_tagline: 'Your trusted AllChinaBuy spreadsheet resource hub',
  footer_links: 'Quick Links',
  footer_legal: 'Legal',
  footer_privacy: 'Privacy Policy',
  footer_terms: 'Terms of Service',
  footer_disclaimer: 'Disclaimer',
  footer_editorial: 'Editorial Policy',
  footer_copyright: '© 2026 allchinabuyspread.de. All rights reserved.',
  footer_nofollow_notice: 'All external links to third-party sites are nofollow.',
  
  // Breadcrumb
  breadcrumb_home: 'Home',
  
  // Misc
  scroll_to_top: 'Scroll to top',
  loading: 'Loading...',
  
  // SEO Article specific
  article_h1: 'AllChinaBuy Spreadsheet Guide — Complete 2026 Resource',
  article_intro: 'Welcome to the most comprehensive AllChinaBuy spreadsheet guide available online. Whether you are new to the platform or a seasoned buyer looking to optimize your product research, this guide covers everything you need to know about leveraging AllChinaBuy spreadsheets for smarter shopping.',
  article_what_is_title: 'What is the AllChinaBuy Spreadsheet?',
  article_what_is_p1: 'The AllChinaBuy spreadsheet is a curated collection of product links, seller information, pricing data, and quality control (QC) notes organized in an easy-to-navigate format. Think of it as a product catalog that connects you directly to verified sellers across popular categories like shoes, hoodies, t-shirts, jackets, and accessories.',
  article_what_is_p2: 'Unlike random product lists you might find on forums or social media, a well-maintained AllChinaBuy spreadsheet provides structured data including category filters, price ranges, seller ratings, and direct purchase links. This organization saves you significant time and reduces the risk of buying from unreliable sources.',
  article_how_to_title: 'How to Use the AllChinaBuy Spreadsheet Effectively',
  article_how_to_step1: 'Start by identifying the product category you are interested in. The spreadsheet is typically organized by categories such as Shoes, Clothing, Accessories, Bags, and Electronics. Use the category filter to narrow down your search.',
  article_how_to_step2: 'Review the seller information and QC notes before clicking any product link. Look for sellers with consistent positive feedback and recent transaction history. The spreadsheet should include seller verification indicators where possible.',
  article_how_to_step3: 'Compare prices across similar products. The AllChinaBuy spreadsheet often includes multiple options for the same type of product, allowing you to find the best balance between quality and price.',
  article_how_to_step4: 'Use the shipping cost estimates provided in the spreadsheet to calculate your total landed cost. Factor in any potential customs duties depending on your destination country.',
  article_categories_title: 'Popular Product Categories in the Spreadsheet',
  article_safety_title: 'Safety Tips When Using AllChinaBuy Spreadsheets',
  article_safety_p1: 'While AllChinaBuy spreadsheets are incredibly useful tools, it is important to practice safe shopping habits. Always verify that the spreadsheet you are using comes from a trusted source. Avoid spreadsheets shared on unverified forums or by unknown users.',
  article_safety_p2: 'Before making any purchase, double-check the product link and ensure it directs to the official AllChinaBuy platform. Be cautious of shortened URLs or links that redirect through multiple domains. If a deal seems too good to be true, it probably is.',
  article_shipping_title: 'Understanding AllChinaBuy Shipping Costs',
  article_shipping_p1: 'Shipping costs from AllChinaBuy vary depending on your location, the weight of your items, and the shipping method you choose. Common options include standard postal services, express couriers like DHL and EMS, and consolidated shipping services.',
  article_shipping_p2: 'European buyers should be aware that packages may be subject to VAT and customs duties upon arrival. These additional costs are not included in the product price or shipping fee displayed on the AllChinaBuy platform. Always budget for potential import charges to avoid surprises.',
  article_faq_title: 'Frequently Asked Questions',
  faq_q1: 'Is the AllChinaBuy spreadsheet free to use?',
  faq_a1: 'Most AllChinaBuy spreadsheets shared by the community are free to access. However, some premium or extensively curated spreadsheets may require a small fee or subscription. We recommend starting with free community resources before considering paid options.',
  faq_q2: 'How often are the spreadsheets updated?',
  faq_a2: 'Update frequency varies by creator. High-quality spreadsheets are typically updated weekly or bi-weekly to reflect current stock levels, pricing changes, and new product arrivals. Always check the last updated date before using a spreadsheet.',
  faq_q3: 'Can I trust the sellers listed in the spreadsheets?',
  faq_a3: 'Trusted spreadsheet creators vet sellers before including them. However, we always recommend doing your own verification. Check recent reviews, transaction history, and QC photos before committing to a purchase.',
  faq_q4: 'What should I do if a product link is broken?',
  faq_a4: 'Broken links can happen when products go out of stock or sellers update their listings. Report broken links to the spreadsheet creator if possible. Alternatively, use the product description and image to search for the item directly on AllChinaBuy.',
  faq_q5: 'Are the prices in the spreadsheet accurate?',
  faq_a5: 'Prices are accurate at the time of the spreadsheet update. However, sellers may change prices without notice. Always verify the current price on the AllChinaBuy platform before completing your purchase.',
  article_conclusion_title: 'Conclusion',
  article_conclusion: 'The AllChinaBuy spreadsheet is an indispensable tool for anyone looking to shop smarter on the AllChinaBuy platform. By understanding how to navigate categories, verify sellers, and estimate total costs, you can significantly improve your shopping experience and find better products at fair prices. Bookmark this guide and return whenever you need a refresher on AllChinaBuy spreadsheet best practices.',
  article_cta: 'Explore More AllChinaBuy Resources',
  
  // Disclaimer
  disclaimer: 'Disclaimer: This website is an independent resource hub and is not affiliated with AllChinaBuy. Product prices, availability, and policies may change. Always verify information directly on the official platform before making purchases.',
  
  // Not Found
  notfound_title: 'Page Not Found',
  notfound_desc: 'The page you are looking for does not exist.',
  notfound_back: 'Back to Home',
};

export default common;